import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { FileText, Image as ImageIcon } from "lucide-react";

export default function EvidenceRegister() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/evidence").then(r => setItems(r.data)); }, []);
  const filtered = items.filter(i => !q || (i.file_name + i.category).toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-4 md:p-8" data-testid="evidence-register-page">
      <div className="mb-6 flex items-end justify-between gap-3">
        <div>
          <div className="overline mb-1">Register</div>
          <h1 className="font-heading text-3xl font-black tracking-tighter sm:text-4xl">Evidence</h1>
          <p className="text-sm text-slate-600">Photos, dockets, test reports, conformance certificates.</p>
        </div>
        <Input placeholder="Search…" value={q} onChange={e=>setQ(e.target.value)} className="w-64" data-testid="evidence-search"/>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6">
        {filtered.map(i => (
          <Card key={i.id} className="border-slate-200 p-3" data-testid={`evidence-tile-${i.id}`}>
            <div className="flex aspect-square items-center justify-center rounded bg-slate-100 text-slate-500">
              {i.file_type?.startsWith("image/") ? <ImageIcon className="size-10"/> : <FileText className="size-10"/>}
            </div>
            <div className="overline mt-2">{i.category}</div>
            <div className="truncate text-xs font-semibold" title={i.file_name}>{i.file_name}</div>
            <div className="mt-1 text-[10px] text-slate-500">{new Date(i.uploaded_at).toLocaleDateString()} · {i.uploaded_by_name}</div>
          </Card>
        ))}
        {filtered.length === 0 && <div className="col-span-full text-sm text-slate-500">No evidence found.</div>}
      </div>
    </div>
  );
}
